import { createSelector } from 'reselect';
import { AppState } from '../../';

export const getAppBackend = (state: AppState) => state.appBackend;
export const getDashboardDetailViewLoading = (state: AppState) =>
  state.appBackend.dashboardDetailViewLoading;

export const namedElementSettings = createSelector(
  getAppBackend,
  appBackend => appBackend.namedElementSettings,
);

export const namedElementDetailView = createSelector(
  getAppBackend,
  appBackend => appBackend.namedElementDetailView,
);

export const namedElementSettingsPageInfo = createSelector(getAppBackend, appBackend => {
  const { data } = appBackend.namedElementSettings;
  if (data) {
    return data.pageInfo;
  }
  return null;
});

export const getActiveElementCount = (state: AppState): number =>
  state.appBackend.namedElementSettings.data?.activeCount ?? 0;

export const getActiveElementLimit = (state: AppState): number =>
  state.appBackend.namedElementSettings.data?.activeLimit ?? -1;

export const definedEventSettings = createSelector(
  getAppBackend,
  appBackend => appBackend.definedEventSettings,
);

export const definedEventSettingsPageInfo = createSelector(getAppBackend, appBackend => {
  const { data } = appBackend.definedEventSettings;
  if (data) {
    return data.pageInfo;
  }
  return null;
});

export const definedEventDetailView = createSelector(
  getAppBackend,
  appBackend => appBackend.definedEventDetailView,
);

export const getActiveEventCount = (state: AppState): number =>
  state.appBackend.definedEventSettings.data?.activeCount ?? 0;

export const getActiveEventLimit = (state: AppState): number =>
  state.appBackend.definedEventSettings.data?.activeLimit ?? -1;

export const getAPIEventCount = (state: AppState): number =>
  state.appBackend.definedEventSettings.data?.customApiEventCount ?? 0;

export const getUserDefinedEventCount = (state: AppState): number =>
  state.appBackend.definedEventSettings.data?.definedEventCount ?? 0;

export const apiEventDetailView = createSelector(
  getAppBackend,
  appBackend => appBackend.apiEventDetailView,
);

export const pageSettings = createSelector(getAppBackend, appBackend => appBackend.pageSettings);

export const pageDetailView = createSelector(
  getAppBackend,
  appBackend => appBackend.pageDetailView,
);

export const pageSettingsPageInfo = createSelector(getAppBackend, appBackend => {
  const { data } = appBackend.pageSettings;
  if (data) {
    return data.pageInfo;
  }
  return null;
});

export const getActivePageCount = (state: AppState): number =>
  state.appBackend.pageSettings.data?.activeCount ?? 0;

export const getLearnedPageCount = (state: AppState): number =>
  state.appBackend.pageSettings.data?.learnedCount ?? 0;

export const getArchivedPageCount = (state: AppState): number =>
  state.appBackend.pageSettings.data?.archivedCount ?? 0;

export const getSuggestedPageCount = (state: AppState): number =>
  state.appBackend.pageSettings.data?.suggestedCount ?? 0;

export const propertySettings = createSelector(
  getAppBackend,
  appBackend => appBackend.propertySettings,
);

export const propertySettingsPageInfo = createSelector(getAppBackend, appBackend => {
  const { data } = appBackend.propertySettings;
  if (data) {
    return data.pageInfo;
  }
  return null;
});

export const propertyDetailView = createSelector(
  getAppBackend,
  appBackend => appBackend.propertyDetailView,
);

export const getActivePropertyCount = (state: AppState): number =>
  state.appBackend.propertySettings.data?.activeCount ?? 0;

export const getApiEventPropertyCount = (state: AppState): number =>
  state.appBackend.propertySettings.data?.apiEventPropertyCount ?? -1;

export const getApiEventPropertyLimit = (state: AppState): number =>
  state.appBackend.propertySettings.data?.apiEventPropertyLimit ?? -1;

export const getElementPropertyCount = (state: AppState): number =>
  state.appBackend.propertySettings.data?.elementPropertyCount ?? -1;

export const getElementPropertyLimit = (state: AppState): number =>
  state.appBackend.propertySettings.data?.elementPropertyLimit ?? -1;

export const getPagePropertyCount = (state: AppState): number =>
  state.appBackend.propertySettings.data?.pagePropertyCount ?? -1;

export const getPagePropertyLimit = (state: AppState): number =>
  state.appBackend.propertySettings.data?.pagePropertyLimit ?? -1;

export const getUserPropertyCount = (state: AppState): number =>
  state.appBackend.propertySettings.data?.userPropertyCount ?? -1;

export const getUserPropertyLimit = (state: AppState): number =>
  state.appBackend.propertySettings.data?.userPropertyLimit ?? -1;
